import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Input } from "@rocketseat/unform";
import CurrencyField from "../../../../../components/CurrencyField";
import { Row, Col, Button } from "antd";
import { useContratoFields } from "../use-contrato-fields";
import { format } from "../../../../../utils/MoneyFormater";

export function ContratoField({ fieldId, valorAcordo }) {
  const {
    addField,
    removeField,
    valorTotalContratos,
    updateFieldValue
  } = useContratoFields();
  const [valorContrato, setValorContrato] = useState(0);

  const handleValorContratoChange = value => setValorContrato(value);

  useEffect(() => {
    updateFieldValue(fieldId, valorContrato);
  }, [valorContrato, fieldId]);

  //  (fórmula: percentual = (valor_de_um_contrato * 100) / soma_dos_contrato).
  const percentual = ((valorContrato * 100) / valorTotalContratos).toFixed(2);
  const valorTotal = ((parseFloat(percentual) * valorAcordo) / 100).toFixed(2);

  return (
    <div style={{ padding: "10px" }}>
      <Input type="hidden" name={`percentual_${fieldId}`} value={percentual} />
      <Input type="hidden" name={`valor_total_${fieldId}`} value={valorTotal} />

      <Row gutter={16} style={{ margin: 0 }}>
        <Col span={4}>
          <div className="acordo__field" style={{ padding: 0 }}>
            <label>Contrato ({fieldId}):</label>
            <Input
              name={`contrato${fieldId}`}
              className="ant-input"
              type="text"
            />
          </div>
        </Col>
        <Col span={4}>
          <div className="acordo__field" style={{ padding: 0 }}>
            <label>Carteira/Produto:</label>
            <Input
              name={`carteira_produto_${fieldId}`}
              className="ant-input"
              type="text"
            />
          </div>
        </Col>
        <Col span={4}>
          <div className="acordo__field" style={{ padding: 0 }}>
            <label>Valor do contrato:</label>
            <CurrencyField
              name={`valor_contrato_${fieldId}`}
              className="ant-input"
              onChangeEvent={handleValorContratoChange}
              type="text"
            />
          </div>
        </Col>
        <Col span={2} style={{ textAlign: "center" }}>
          <label>Percentual:</label>
          <div style={{ padding: "10px 0 6px 0" }}>
            <span>{isNaN(percentual) ? 0 : percentual}%</span>
          </div>
        </Col>
        <Col span={2} style={{ textAlign: "center" }}>
          <label>Valor total:</label>
          <div style={{ padding: "10px 0 6px 0" }}>
            <span>R$ {isNaN(valorTotal) ? "0,00" : format(valorTotal)}</span>
          </div>
        </Col>
        <Col
          span={1}
          style={{
            textAlign: "center"
          }}
        >
          <div style={{ padding: "10px 0" }}>
            {fieldId <= 1 ? (
              <Button
                type="primary"
                icon="plus"
                title="Adicionar novo campo de contrato"
                onClick={addField}
              />
            ) : (
              <Button
                type="danger"
                onClick={() => removeField(fieldId)}
                icon="close"
                title="Remover campo"
              />
            )}
          </div>
        </Col>
      </Row>
    </div>
    // <Row gutter={8}>
    //   <div className="contrato__field">
    //     <label>Contrato:</label>
    //     <Input name={"contrato" + i} className="ant-input" type="text"></Input>
    //     {this.getButtonContrato(i)}
    //   </div>
    // </Row>
  );
}

ContratoField.propTypes = {
  onAddFieldPress: PropTypes.func,
  onRemoveFieldPress: PropTypes.func,
  fieldIndex: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/pages/Acordo/Create/Formulario/ContratoField/index.jsx